import React from 'react';
import { Container } from 'react-bootstrap';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="modern-footer">
      <Container>
        <div className="footer-bottom">
          <p className="text-center">&copy; {new Date().getFullYear()} Rahul Bhoyar. All rights reserved.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
